import { Form, Input, Select } from "antd";
import InputDate from "components/InputDate";
import disabled_note_datetime from "helpers/disabled_note_datetime";
import { useWorkers } from "context/providers/workers";
import { MaskedInput } from "antd-mask-input";
import issue_statuses from "helpers/options/issue_statuses";
import {
  building_number_regexp,
  apartment_number_regexp,
  street_regexp,
} from "helpers/regexp";

const getValidators = (name) => {
  switch (name) {
    case "client_street":
      return [
        {
          required: true,
          message: "Ulica jest wymagane!",
        },
        {
          pattern: street_regexp,
          message: "Pole zawiera niedozwolone znaki!!",
        },
      ];
    case "client_building_number":
      return [
        {
          required: true,
          message: "Numer budynku jest wymagany!",
        },
        {
          pattern: building_number_regexp,
          message:
            "Pole zawiera niedozwolone znaki lub nie zaczyna się od cyfry!",
        },
      ];
    case "client_apartment_number":
      return [
        {
          required: true,
          message:
            "Numer mieszkania jest wymagany, w przypadku domu jednorodzinnego proszę wpisać -",
        },
        {
          pattern: apartment_number_regexp,
          message:
            "Pole zawiera niedozwolone znaki lub nie zaczyna się od cyfry!",
        },
      ];
    default:
      return [];
  }
};

const InputNode = ({ name, title, workers_list_options, record }) => {
  switch (name) {
    case "worker_id":
      return (
        <Form.Item name="worker_id" style={{ margin: 0 }}>
          <Select
            options={[{ label: "Brak", value: null }, ...workers_list_options]}
          />
        </Form.Item>
      );
    case "service_date":
      return (
        <Form.Item name="service_date" style={{ margin: 0 }}>
          <InputDate
            format="DD-MM-YYYY HH:mm"
            showTime={{ format: "HH:mm" }}
            disabledTime={disabled_note_datetime}
          />
        </Form.Item>
      );
    case "status":
      return (
        <Form.Item name="status" style={{ margin: 0 }}>
          <Select placeholder="Status" options={issue_statuses} />
        </Form.Item>
      );
    case "client_phone":
      return (
        <Form.Item
          style={{ margin: 0 }}
          name="client_phone"
          rules={[
            () => ({
              validator(_, value) {
                if (!value) {
                  return Promise.reject(new Error("Numer telefonu wymagany!"));
                }
                if (value.includes("_")) {
                  return Promise.reject(
                    new Error("Numer telefonu niepoprawny!")
                  );
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <MaskedInput mask="000000000" />
        </Form.Item>
      );
    default:
      return (
        <Form.Item
          name={name}
          style={{ margin: 0 }}
          rules={getValidators(name)}
        >
          <Input placeholder={title} />
        </Form.Item>
      );
  }
};

const EditableCell = ({
  editing,
  dataIndex: name,
  title,
  children,
  record,
  ...restProps
}) => {
  const { workers_list_options } = useWorkers();
  return (
    <td {...restProps}>
      {editing ? (
        <InputNode {...{ name, title, workers_list_options, record }} />
      ) : (
        children
      )}
    </td>
  );
};

export default EditableCell;
